import React, { useState } from 'react';
import HelmetTitle from '../HelmetTitle/HelmetTitle';
import { API_TOKEN } from '../../api';
import './LoginPage.css';

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        'https://demo.api.da-capital.io/v1/auth/admin/login',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            token: API_TOKEN,
          },
          body: JSON.stringify({ username, password }),
        }
      );

      if (!response.ok) {
        let apiMessage = response.statusText;

        try {
          const errorData = await response.json();
          if (errorData && errorData.message) {
            apiMessage = errorData.message;
          }
        } catch {
          /* ignore JSON parse errors */
        }

        setError(`❗️Authorization error: ${response.status} - ${apiMessage}`);
        return;
      }

      const data = await response.json();
      localStorage.setItem('accessToken', data.accessToken);
      localStorage.setItem('refreshToken', data.refreshToken);

      onLogin();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <HelmetTitle title="Login" />
      <form className="login-form" onSubmit={handleSubmit}>
        <img
          className="logo"
          src={process.env.PUBLIC_URL + '/tsfc_logo.png'}
          alt="TSFC Logo"
        />
        <h1 className="title">Admin Panel</h1>
        <p className="expired-note">
          <span role="img" aria-label="hourglass">
            ⏳
          </span>{' '}
          Session expired. Please sign in again.
        </p>
        <div className="input-group">
          <label htmlFor="login">Login</label>
          <input
            id="login"
            type="text"
            placeholder="Enter login"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && <p className="login-error">{error}</p>}
        <button type="submit" className="sign-in-button">
          <i className="fas fa-sign-in-alt" />
          <span>Log in</span>
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
